import z from "zod";

// Used for manual errors thrown during synthetic tests
const monitorsErrorTypeValues = [
  "REMI_NEXTJS_API_DOWN",
  "REMI_TRPC_RESPONSE_ERROR",
  "REMI_APP_DOWN",
  "REMI_PORTAL_DOWN",
  "BROWSER_NOT_STARTED",
  "TEST_VERSION_MONITOR",
] as const;

const monitorsErrorTypeSchema = z.enum(monitorsErrorTypeValues);
const MonitorsErrorType = monitorsErrorTypeSchema.enum;
export type MonitorsErrorType = z.infer<typeof monitorsErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type MonitorsErrors =
  | {
      errorType: typeof MonitorsErrorType.REMI_TRPC_RESPONSE_ERROR;
      data: {
        trpcPath: string;
        url: string;
        status: number;
        statusText: string;
      };
    }
  | {
      errorType: typeof MonitorsErrorType.REMI_APP_DOWN | typeof MonitorsErrorType.REMI_PORTAL_DOWN;
      data:
        | Record<string, never>
        | {
            errorText: string;
            url: string;
          };
    }
  | {
      errorType: Exclude<
        MonitorsErrorType,
        | typeof MonitorsErrorType.REMI_TRPC_RESPONSE_ERROR
        | typeof MonitorsErrorType.REMI_APP_DOWN
        | typeof MonitorsErrorType.REMI_PORTAL_DOWN
      >;
      data: Record<string, never>;
    };

export const monitorsErrorDetails: Record<MonitorsErrorType, ErrorDetails> = {
  [MonitorsErrorType.REMI_NEXTJS_API_DOWN]: {
    sentryDescription: "Remi app nextjs api is down",
  },
  [MonitorsErrorType.REMI_TRPC_RESPONSE_ERROR]: {
    sentryDescription: "Remi trpc response error",
  },
  [MonitorsErrorType.REMI_APP_DOWN]: {
    sentryDescription: "Remi app is down",
  },
  [MonitorsErrorType.REMI_PORTAL_DOWN]: {
    sentryDescription: "Remi homeowner portal is down",
  },
  [MonitorsErrorType.BROWSER_NOT_STARTED]: {
    sentryDescription: "Browser not started. Call startBrowser() first.",
  },
  [MonitorsErrorType.TEST_VERSION_MONITOR]: {
    sentryDescription: "Test version monitor is down",
  },
};
